import React, { useMemo } from 'react';
import { connect } from 'react-redux';

import { getTranslatedString } from 'helpers/i18n';
import { sizes } from 'helpers/MediaHelper';

import { colors } from 'helpers/ColorHelper';

import Form from 'components/ui/Form';
import Spacer from 'components/ui/Spacer';
import { AntdRadioGroupButton as RadioButton } from 'ui-library/components/RadioGroupButton/RadioGroupButton';

import { isNoticeOfEntryNotice, isLegalNotice } from '../NoticeTemplateHelpers';

const styles = {
  radioHeader: {
    fontWeight: '900',
    fontSize: '16px',
    marginTop: 0,
    marginBottom: 0,
  },
};

const DeliveryInput = ({ values, errors, touched, setFieldValue }) => {
  const isMobile = window.matchMedia(`(max-width: ${sizes.mobile}px)`).matches;

  const handleChange = (event) => {
    const delivery = event.target.value;
    setFieldValue('delivery', delivery);
  };

  const restrictedNotice = useMemo(() => {
    return isLegalNotice(values) || isNoticeOfEntryNotice(values);
  }, [values]);

  const radioTextStyle = useMemo(() => {
    return restrictedNotice ? { color: colors.DISABLED_GRAY } : {};
  }, [restrictedNotice]);

  const deliveryOptions = useMemo(() => {
    return [
      {
        value: 'any',
        label: (
          <span style={radioTextStyle}>
            <p style={styles.radioHeader}>
              {getTranslatedString('landlordPortal.noticeTemplateForm.any')}
            </p>
            <p style={{ marginTop: 0 }}>
              {getTranslatedString('landlordPortal.noticeTemplateForm.anySub')}
            </p>
          </span>
        ),
        disabled: restrictedNotice,
      },
      {
        value: 'single_property',
        label: (
          <span style={radioTextStyle}>
            <p style={styles.radioHeader}>
              {getTranslatedString('landlordPortal.noticeTemplateForm.property')}
            </p>
            <p style={{ marginTop: 0 }}>
              {getTranslatedString('landlordPortal.noticeTemplateForm.propertySub')}
            </p>
          </span>
        ),
        disabled: restrictedNotice,
      },
      {
        value: 'single_unit',
        label: (
          <span>
            <p style={styles.radioHeader}>
              {getTranslatedString('landlordPortal.noticeTemplateForm.unit')}
            </p>
            <p style={{ marginTop: 0 }}>
              {getTranslatedString('landlordPortal.noticeTemplateForm.unitSub')}
            </p>
          </span>
        ),
      },
    ];
  }, [restrictedNotice, radioTextStyle]);

  return (
    <>
      <Form.Item label={getTranslatedString('landlordPortal.noticeTemplateForm.delivery')}>
        <Spacer mt={1} />
        <RadioButton
          radioGroupData={deliveryOptions}
          name="delivery"
          vertical={true}
          value={values.delivery}
          handleChange={handleChange}
          error={touched.delivery && errors.delivery}
          isMobile={isMobile}
        />
      </Form.Item>
    </>
  );
};

export default connect((store) => ({}), {})(DeliveryInput);
